'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportUsage = undefined;

var _tcss_report = require('./tcss_report');

var _tcss_report2 = _interopRequireDefault(_tcss_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 第一个路径
var pathname = function () {
    var pathArray = location.pathname.split('/') || [];
    var result = '';

    if (pathArray.length > 0) {
        result = pathArray[0] || pathArray[1];
    }

    return result;
}().replace(/\./g, '_');
var hostname = (location.host || location.hostname || '').replace(/\./g, '_');
var protocol = location.protocol || '';

/**
 * 上报使用率
 * @param  {Object} config 上报配置
 *                  config.scope 作用域名称
 *                  config.name 组件名称
 *                  config.version 组件版本
 *                  config.timeout 延迟上报时间
 */
var reportUsage = exports.reportUsage = function reportUsage() {
    // 目前使用范围已经很广，不做上报了

    // const { scope = '', version = '', timeout = 3000, name = '' } = config;
    // let hottag = '',
    //     tcssName = '';

    // // 不上报
    // if (
    //     !scope ||
    //     !name ||
    //     name.indexOf('spaui-') === 0 || // 小包不做上报了，优先推荐大包
    //     protocol.indexOf('http') !== 0 ||
    //     hostname.indexOf('localhost') === 0 ||
    //     hostname === 'spaui.oa.com' ||
    //     hostname === 'f.gdt.isd.com' ||
    //     !(typeof window === 'object' && window.sessionStorage && window.sessionStorage.getItem)
    // ) {
    //     return false;
    // }

    // hottag = [scope, name + '@' + version.replace(/\./g, 'v')].join('.').toLowerCase();
    // tcssName = hottag + '.' + hostname + '/' + pathname;
    // if (hottag && !window.sessionStorage.getItem(hottag)) {
    //     // 延迟上报，不影响主页面的逻辑
    //     setTimeout(() => {
    //         tcssReport(tcssName, () => {
    //             window.sessionStorage.setItem(hottag, 1);
    //         });
    //     }, timeout);
    // }

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
};

exports.default = reportUsage;